function shuffle(arr) {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

export function welcomeBgRandomizer() {
    const picture = document.querySelector('.section-welcome .block-bg[data-bg-base]');
    if (!picture) return;

    const basePath = picture.getAttribute('data-bg-base');

    let images;
    try {
        images = JSON.parse(picture.getAttribute('data-bg-images') || '[]');
    } catch {
        return;
    }
    if (!images.length) return;

    const queueKey = 'welcomeBgQueue';
    let queue;
    try {
        queue = JSON.parse(sessionStorage.getItem(queueKey) || '[]');
    } catch {
        queue = [];
    }
    if (!queue.length) queue = shuffle(images);

    const nextIndex = queue.shift();
    try {
        sessionStorage.setItem(queueKey, JSON.stringify(queue));
    } catch {
        // storage not available
    }

    const sources = picture.querySelectorAll('source');
    if (sources[0]) sources[0].srcset = `${basePath}/bg-welcome-${nextIndex}-mob.jpg`;
    if (sources[1]) sources[1].srcset = `${basePath}/bg-welcome-${nextIndex}.jpg`;

    const img = picture.querySelector('img');
    if (img) img.srcset = `${basePath}/bg-welcome-${nextIndex}.jpg`;
}